/**
 * Schema of Motorista Transbordo
 * @author ftgibran
 */
import {InputType, Schema} from 'simpli-web-sdk'
import MotoristaTransbordo from '@/model/resource/MotoristaTransbordo'
import * as Helper from '@/helpers'

export default (model: MotoristaTransbordo): Schema => ({
  podeEntregar: {
    content: Helper.bool(model.podeEntregar),
    input: InputType.CHECKBOX,
  },

  podeReceber: {
    content: Helper.bool(model.podeEntregar),
    input: InputType.CHECKBOX,
  },
})
